import Vue from 'vue';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { required , maxLength , numeric , between} from 'vuelidate/lib/validators'
import KEYS from '../../../../../values/keys';
import { ED_DROPZONE_EVENTS } from '../../../../values/events';
import { COURSE_API } from '@/courses/values/courses.values';
import { SectionsProvider } from '@/content/providers/sections.provider';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';
import { MULTIMEDIA_FILES_TYPES_EXT } from '@/courses/values/courses.values'
import { SERVER_HOSTNAME } from '@/shared/enums/request.enum';
import { RequestProvider } from '@/shared/providers/request.provider';
import EdSelectComponentCourse from '@/course-templates/components/ed-select-component-course/ed-select-component-course.component.vue';

export default Vue.component('ed-upload-course-material', {
  name: 'ed-upload-course-material',
  props: ['params'],
  mixins: [CourseToolsMixin],
  components:{
    EdSelectComponentCourse,
  },
  data: () => {
    return {
      dropzoneMode: KEYS.DROPZONE_CONFIG.SINGLE,
      fileUploaded: null,
      extension: '',
      edition: false,
      isUploading: false,
      isUpdating: false,
      materialFileName: null,
      message: null,
      materialId: null,
      updateMaterial: false,
      form: EdFormModel([ EdInputModel('name', '', { required, maxLength: maxLength(70)}),
      EdInputModel('offset', '', { numeric, between: between(0,1) }),]),
      key:'',
      dropOptions: {},
      showEduacComponentModal: false,
      paramsComponent: {},
    }
  },
  computed:{
    removeFileExtension() {
      if(this.fileUploaded)
        return this.fileUploaded.name.substring(0,this.fileUploaded.name.lastIndexOf('.'));
      else
        return '';
    },
    checkForm() {
      if(!this.edition) {
        return !this.form.name.valid || !this.fileUploaded || !this.fileUploaded.accepted
      } else {
        return !this.form.valid
      }
    },
    checkNumberPages() {
      let numberOfPages = this.params.material.data.numberOfPages;
      if(numberOfPages) {
        this.form.setValidator('offset', 'between', between(0, numberOfPages));
        return true;
      } else {
        return false;
      }
    },
    courseId() {
      return this.edition ? this.params.material.courseId : this.params.courseId;
    },
    classId() {
      return this.edition ? this.params.material.classId : this.params.classId;
    },
    course() {
      return this.getCourseFromStore({courseId: this.courseId , classId: this.classId});
    },
    components() {
      return this.course.eduacComponents;
    },
    componentSelected: {
      get() {
        return this.$store.state.CourseStore.eduacComponentSelected;
      },
      set(newValue) {
        this.$Courses.Store.setEduacComponentSelected(newValue);
      }
    }
  },
  methods: {
    changeComponent(data) {
      this.componentSelected = data;
    },
    showParentForm(data) {
      this.showEduacComponentModal = false;
    },
    async onFileUploadedSuccess(resObj) {  
      await this.$Courses.Store.addCourseMaterialA({
        material: resObj.res , courseId: this.courseId , classId: this.classId
      });
      let materialInfo = {materialId: resObj.res.id, courseId: this.courseId , classId: this.classId};
      setTimeout(() => {
        this.goToMaterialPreview(materialInfo);
      },0);
      await this.getContentForCourse(materialInfo);
      this.isUploading = false;
      this.closeModal();
    },
    saveFile() {
      if(this.edition) {
        let areMaterialsRelated = false;
        this.materialId ?  areMaterialsRelated = SectionsProvider.getCourseMaterialsRelated(this.course.sections,
        this.materialId) : null;
        areMaterialsRelated ? this.updateFile(false) : this.updateFile(false);
        /* when offset active again call getConfirmation instead of updatefile*/
      } else {
        this.isUploading = true;
        this.$edEventBus.$emit(ED_DROPZONE_EVENTS.UPLOAD_FILE, { material: { name: this.form.name.value ,
          materialSectionId: this.params.sectionId , offset: this.form.offset.value, component: this.componentSelected }});
      }            
    },
    updateFile(recreate = false) {
      this.isUpdating = true;
      let data = { name: this.form.name.value , offset: this.form.offset.value , recreate: recreate,
      materialId: this.materialId, component: this.componentSelected }
      this.$Courses.Store.updateCourseMaterialA({
        data, courseId: this.courseId
      })
      .then(async () => {
        let materialInfo = {courseId: this.courseId , classId: this.classId}
        await this.getContentForCourse(materialInfo);
        this.goToMaterialPreview({...materialInfo , materialId: this.materialId });
        this.closeModal();
      })
      .catch((res) =>  {
        this.isUpdating = false;
        this.setErrorMessage(res.data.message);
      });
    },
    getConfirmation() {
      this.$EdModal.createConfirmationModal({
        body: this.$i18n.t('courses.materials.updateCourseMaterial'),
        actionText: this.$i18n.t('common.submit'),
        action: (res) => {
          let option = res.optionRadioValue === 'first' ? false : true;
          this.updateFile(option)
        },
        hasOptionRadio: true,
        firstOptionRadioText: this.$i18n.t('courses.materials.updatePageNumbers'),
        secondOptionRadioText: this.$i18n.t('courses.materials.updateCourseMaterialObjects'),
      });    
    },
    setErrorMessage(message) {
      let offset = parseInt(message.split(':')[1])
      this.message = `${this.$i18n.t('courses.materials.offsetError', { offset: offset , pages: offset + 1})}`
    },
    removeFile() {
      this.fileUploaded = null;
    },
    onFileAdded(file) {
      this.fileUploaded = file;
      this.form.name.value = this.removeFileExtension;
      this.key = this.removeFileExtension;      
    },
    onUploadError(error) {
      this.isUploading = false;
      if(error.message.status === 400 && error.message.errors) {
        let errors = error.message.errors[0];
        let epubVersion = errors.attributes.epubVersion;
        this.message = this.$i18n.t(`courses.errors.codes.${errors.status}`).replace('{epubVersion}', epubVersion);
      } else {
        this.setErrorMessage(error.message);
      }
      this.fileUploaded = null;
    },
    closeModal() {
      this.$EdModal.closeModal();
    },
    setDropOptions() {
      const headers = RequestProvider.getTokenHeader();
      const path = COURSE_API.CREATE_COURSE_MATERIAL.replace('{courseId}', this.courseId);
      const url = `${process.env[SERVER_HOSTNAME.COMMON]}/${path}`;
      this.dropOptions = {
        url,
        autoProcessQueue: false,
        acceptedFiles: 'application/pdf, .epub,.docx,.doc,.mp3,.wav,.mp4',
        addRemoveLinks: true,
        uploadMultiple: false,
        maxFiles: 1,
        maxFilesize: 200,
        parallelUploads: 1,
        createImageThumbnails: false,
        timeout: 600000,
        headers
      }
    }
  },
  created() {
    this.setDropOptions();
    if(this.params.editing) {
      this.edition = this.params.editing;
      this.form.name.value = this.params.material.data.title
      this.form.offset.value = 0;
      this.form.setValid('offset', true);
      this.materialId = this.params.material.relatedContentId
      this.updateMaterial = true;
      if(MULTIMEDIA_FILES_TYPES_EXT[this.params.material.data.mimeType]) {
        let ext = MULTIMEDIA_FILES_TYPES_EXT[this.params.material.data.mimeType];
        this.materialFileName = `${this.form.name.value}${ext}`;
      } else {
        let ext = SectionsProvider.getExtensionFromSectionType(`LESSON_${this.params.material.data.subtype}`);
        this.materialFileName = `${this.form.name.value}.${ext}`;
      }
      if(this.params.material.component) {
        this.componentSelected = this.components.find(c => c.id == this.params.material.component.id);
      } else if(this.components) {
        this.componentSelected = this.components.find(c => c.mandatory);
      }
    } else if(this.course.eduacComponents) {
      this.componentSelected = this.components.find(c => c.mandatory);
    }
  },
});